export default class UtilityFunctions {

  static verifyImageURL(url: string, baseUrl: string): string {
    if (url) {
      if(url.includes('http')) return url;
      if (url.startsWith('/')) url = url.substring(1);
      const sub = url.substring(0, url.indexOf("/"));
      if (sub.toLowerCase().includes("images")) return `${baseUrl}/${url}`;
      else {
        return `${baseUrl}/Images/${url}`;
      }
    } else {
      return '';
    }

  }
}
